// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","link":"Header_link__+IYA6","subLink":"Header_subLink__m3nI+","dropdownFooter":"Header_dropdownFooter__MPooT"};